import React, { useState } from "react";
import RepostBtn from "../../button/RepostBtn";
import ReplyBtn from "../../button/ReplyBtn";
import LikeBtn from "../../button/LikeBtn";
import BookmarkBtn from "../../button/BookmarkBtn";
import ShareBtn from "../../button/ShareBtn";
import "./post-icons.css";

import { newRepost } from "../../../redux/actions/postActions";
import { useDispatch } from "react-redux";
import RatingBtn from "../../button/RatingBtn";

const PostIcons = ({ post }) => {
  const dispatch = useDispatch();

  const repost = () => {
    dispatch(newRepost(post._id));
  };
  return (
    <div className="post-icons">
      <ReplyBtn replies={post.replies.length} id={post._id} />
      <LikeBtn id={post._id} likes={post.likes} />
      {/* <RatingBtn id={post._id} ratings={post.ratings} /> */}
      <RepostBtn id={post._id} reposts={post.reposts.length} />
      <BookmarkBtn id={post._id} />
      <ShareBtn post={post} />
    </div>
  );
};

export default PostIcons;

